const { strapi } = require('../../clients')
const { cache } = require('../../helpers')
const coursesRepository = require('../../repository/courses')

module.exports = class FiltersRepository {
    constructor() {
        // this.type = "course";
        this.country = 'Armenia'
        this.corporate = false
        this.data = {}

        // this.all().then(() => {});
    }

    async getCategories() {
        return await cache(
            'filter-categories',
            async () =>
                await strapi
                    .get('coursetypes')
                    .then((res) => res.data)
                    .then((res) => res.filter((type) => !!type.courses.length))
                    .then((res) =>
                        res.map((type) => {
                            return {
                                label: type.title,
                                value: type.title
                            }
                        })
                    )
        )
    }

    async getLanguages() {
        return await cache(
            'filter-languages',
            async () =>
                await strapi
                    .get('language')
                    .then((res) => res.data)
                    .then((res) =>
                        res.filter((language) => !!language.courses.length)
                    )
                    .then((res) =>
                        res.map((language) => {
                            return {
                                label: language.Name,
                                value: language.Name
                            }
                        })
                    )
        )
    }

    getLevels() {
        return [
            { label: 'Beginner', value: 'A1' },
            { label: 'Elementary', value: 'A2' },
            { label: 'Intermediate', value: 'B1' },
            { label: 'Upper Intermediate', value: 'B2' },
            { label: 'Advanced', value: 'C1' },
            { label: 'Proficiency', value: 'C2' }
        ]
    }

    getTypes() {
        return [
            { label: 'Group', value: true },
            { label: 'Individual', value: false }
        ]
    }

    async getPrices() {
        return await cache('filter-prices', async () => {
            const courses = await new coursesRepository()
                .where('location.country', this.country)
                .where('corporate', this.corporate)
                .all()

            let min = Number.MAX_SAFE_INTEGER,
                max = 0
            for (const course of courses) {
                if (course.price < min) {
                    min = course.price
                }

                if (course.price > max) {
                    max = course.price
                }
            }

            const step = max > 10000 ? 1000 : 10

            return {
                min,
                max,
                step
            }
        })
    }

    async all() {
        const [
            categories,
            languages,
            levels,
            types,
            prices
        ] = await Promise.all([
            this.getCategories(),
            this.getLanguages(),
            this.getLevels(),
            this.getTypes(),
            this.getPrices()
        ])

        return [
            {
                type: 'select',
                label: 'language',
                field: 'language.Name.keyword',
                options: languages
            },
            {
                type: 'select',
                label: 'category',
                field: 'coursetypes.title.keyword',
                options: categories
            },
            {
                type: 'select',
                label: 'level',
                field: 'level.searchLevel.keyword',
                options: levels
            },
            {
                type: 'select',
                label: 'type',
                field: 'Group',
                options: types
            },
            {
                type: 'range',
                label: 'price',
                field: 'price',
                ...prices
            },
            {
                type: 'boolean',
                label: 'free_trial',
                field: 'free_trial'
            },
            {
                type: 'rating',
                label: 'rating',
                field: 'rating'
            }
        ]
    }

    whereCountry(value) {
        this.country = value
    }

    whereCorporate(value) {
        this.corporate = value
    }
}
